import { token } from '@cp/shared/di';
import { SupportCodeStorage } from './types'
import { SupportCodeService } from './service';

export const SUPPORT_CODE_STORAGE = token<SupportCodeStorage>('SUPPORT_CODE_STORAGE');
export const SUPPORT_CODE_SERVICE = token<SupportCodeService>('SUPPORT_CODE_SERVICE');
